import { createPath } from '../../../utils';

export const OnboardingRoutePath = () => ({
  root: () => createPath('/onboarding'),
});
